// extracted by mini-css-extract-plugin
module.exports = {"itemsWrapper":"Block_itemsWrapper__32HUT","item":"Block_item__3SH6v","icon":"Block_icon__IUAlE","title":"Block_title__N4vK_"};